/**
 * remarkSoftBreaks — turn soft line breaks (a single "\n" inside a paragraph or
 * list item) into hard <br> breaks so rendered markdown keeps the author's line
 * structure. CommonMark collapses soft breaks to spaces, which dropped
 * intentional line breaks inside multiline bullets and multi-line retrieved
 * snippets (Action History / citation excerpts). Paragraph breaks ("\n\n") are
 * unaffected — they're already separate block nodes by the time text nodes are
 * walked, and GFM table rows are their own block structure, so tables are
 * untouched. Mirrors remark-breaks without adding a dependency.
 *
 * Extracted from DraftTab so every ReactMarkdown surface shares one definition.
 */
export function remarkSoftBreaks() {
  return (tree: unknown) => {
    const walk = (node: { children?: unknown[] } | null) => {
      if (!node || !Array.isArray(node.children)) return;
      const next: unknown[] = [];
      for (const child of node.children as Array<{ type?: string; value?: string; children?: unknown[] }>) {
        if (child.type === "text" && typeof child.value === "string" && child.value.includes("\n")) {
          const parts = child.value.split("\n");
          parts.forEach((part, i) => {
            if (i > 0) next.push({ type: "break" });
            if (part) next.push({ type: "text", value: part });
          });
        } else {
          walk(child as { children?: unknown[] });
          next.push(child);
        }
      }
      node.children = next;
    };
    walk(tree as { children?: unknown[] });
  };
}
